import type { LucideIcon } from 'lucide-react';

type CapabilityCardProps = {
  title: string;
  body: string;
  icon: LucideIcon;
  accent: string;
  className?: string;
};

export default function CapabilityCard({ title, body, icon: Icon, accent, className = '' }: CapabilityCardProps) {
  return (
    <article className={`capability-card glass-card flex items-center gap-3 rounded-3xl p-3 shadow-glass ${className}`}>
      <div className={`grid h-10 w-10 shrink-0 place-items-center rounded-2xl bg-gradient-to-br ${accent} text-white shadow-lg`}>
        <Icon size={19} aria-hidden="true" />
      </div>
      <div>
        <h3 className="text-sm font-extrabold text-slate-900">{title}</h3>
        <p className="text-xs font-medium leading-snug text-slate-500">{body}</p>
      </div>
    </article>
  );
}
